var _variantColor;
import { variants } from './variants';
import { elo as theme } from '../themes';
export var variantColor = (_variantColor = {}, _variantColor[variants.POSITIVE] = {
  color10: theme.colors.mint10,
  color20: theme.colors.mint20,
  color30: theme.colors.mint30,
  color40: theme.colors.mint40
}, _variantColor[variants.NEGATIVE] = {
  color10: theme.colors.red10,
  color20: theme.colors.red20,
  color30: theme.colors.red30,
  color40: theme.colors.red40
}, _variantColor[variants.INFORMATIVE] = {
  color10: theme.colors.cyan10,
  color20: theme.colors.cyan20,
  color30: theme.colors.cyan30,
  color40: theme.colors.cyan40
}, _variantColor[variants.ATTENTION] = {
  color10: theme.colors.honey10,
  color20: theme.colors.honey20,
  color30: theme.colors.honey30,
  color40: theme.colors.honey40
}, _variantColor[variants.BRAND] = {
  color10: theme.colors.brand10,
  color20: theme.colors.brand20,
  color30: theme.colors.brand30,
  color40: theme.colors.brand40
}, _variantColor[variants.ACCENT] = {
  color10: theme.colors.accent10,
  color20: theme.colors.accent20,
  color30: theme.colors.accent30,
  color40: theme.colors.accent40
}, _variantColor[variants.MAGENTA] = {
  color10: theme.colors.magenta10,
  color20: theme.colors.magenta20,
  color30: theme.colors.magenta30,
  color40: theme.colors.magenta40
}, _variantColor);